import EmissionsBar from './EmissionsBar';

export default EmissionsBar;
